import styles from 'styles/components/common/elements/ChartStatus.module.scss';

type TProps = {
  status: string | null;
};

const ChartStatus = ({ status }: TProps) => {
  if (!status) {
    return null;
  }

  if (status === '제출완료') {
    return <span className={styles.label_submitted}>제출완료</span>;
  } else if (status === '작성중') {
    return <span className={styles.label_writing}>작성중</span>;
  } else if (status === '미작성') {
    return <span className={styles.label_notWritten}>미작성</span>;
  }

  return null;
};

export default ChartStatus;
